module.exports = __webpack_public_path__ + "static/media/20-1.6f976014.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/20-1.JPG
// module id = 225
// module chunks = 0